import { colors as akColors } from '@atlaskit/theme';

import { type ColorPalette } from './types';

export const PageStatusColors = [
  akColors.B200,
  akColors.G200,
  akColors.Y200,
  akColors.R200,
  akColors.P200,
];

export const PageStatusPalette: ColorPalette<PageStatusColor> = {
  backgroundColor: (color) => color,
  textColor: () => akColors.N0,
  swatch: PageStatusColors,
};

export type PageStatusColor = (typeof PageStatusColors)[number];
